// extracted by mini-css-extract-plugin
module.exports = {"outer":"gfeN3","heading":"irvSk","subHeading":"_17NI5"};